<template>
  <div class="hello">
    <h1>Sigfox Monitor</h1>
    <section class="condition">
      <label>
        センサー:
        <input type="text" placeholder="デバイスID / シリアルNo" v-model="id" @keypress.enter="search"/>
      </label>
      <button type="button" @click="search">
        検索
      </button>
      <label v-if="sensor != null">
        更新まで {{ rest }}秒
      </label>
      <button type="button" @click="downloadCsv" v-if="sensor != null">
        CSVダウンロード
      </button>
    </section>
    <ul>
      <li v-for="mes in messages" :key="mes.timestamp" :is="type" :message="mes" ref="payload">
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Monitor',
  props: ['deviceId'],
  data () {
    return {
      format: 1,
      id: this.deviceId,
      sensor: null,
      messages: [],
      rest: 0,
      timeoutId: null,
    }
  },
  computed: {
    type () {
      return 'SensorRecord01';
    }
  },
  methods: {
    async search () {
      if (this.timeoutId != null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.sensor = { id: this.id };
      this.messages = [];

      this.rest = 0;
      await this.updateMessages();
    },
    async updateMessages () {
      if (this.rest === 0) {
        const messages = await this.fetch();
        this.messages = messages.concat(this.messages);
        this.rest = 60;
      } else {
        this.rest--;
      }
      this.timeoutId = setTimeout(() => this.updateMessages(), 1000);
    },
    async fetch () {
      const latest = this.messages[0];
      const query = latest ? `?after=${latest.timestamp + 1}` : '';
      const response = await fetch(`${Global.ApiEndpoint}/messages/${this.id}${query}`);
      const body = await response.json();

      return body.messages;
    },
    async downloadCsv () {
      const index = {};
      const headers = [];
      const lines = [];

      // header
      for (const el of this.$refs.payload) {
        for (const header of el.getHeader()) {
          if (index[header] == null) {
            const i = headers.length;
            index[header] = i;
            headers.push(header);
          }
        }
      }

      // lines
      for (const el of this.$refs.payload) {
        const value = el.getValue();
        const line = [];

        for (const header of headers) {
          const v = value[header];
          line.push(v == null ? '' : v);
        }
        lines.push(line.join());
      }

      const link = document.createElement('a');
      const csv = headers.join() + '\n' + lines.reverse().join('\n') + '\n';
      const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
      link.href = url;
      link.download = `${this.id}.csv`;
      link.click();

      URL.revokeObjectURL(url);
    }
  },
  created() {
    if(this.deviceId) {
      this.search();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  text-align: left;
}
.condition {
  text-align: left;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Monitor.vue